import { Button, Container, Grid, Typography } from '@material-ui/core';
import React from 'react';
import { Banner } from '../../components/AgentResources/Login';
import AppContext from '../../components/AppContext';
import Layout from '../../components/Layout';
import Link from 'next/link';


function RegisterAgentConfirmation() {
  const title = 'Agent Resources'
  const subTitle = 'Agent resources like marketing materials, training, sample illustrations, enrollment forms, and more.'
  const props = {
    title,
    page: {
      'title': {
        'blocks': [
          {
            'key': '9qk7h',
            'text': title,
            'type': 'H2',
            'depth': 0,
            'inlineStyleRanges': [],
            'entityRanges': [],
            'data': {}
          }
        ], 'entityMap': {}
      },
      'subTitle': {
        'blocks': [
          {
            'key': 'fraau',
            'text': subTitle,
            'type': 'SUBTITLE1',
            'depth': 0,
            'inlineStyleRanges': [],
            'entityRanges': [],
            'data': {}
          }
        ], 'entityMap': {}
      },
      'strategyText': {
        'blocks': [
          {
            'key': '5ovo0',
            'text': 'Find Your Strategy',
            'type': 'H4',
            'depth': 0,
            'inlineStyleRanges': [],
            'entityRanges': [],
            'data': {}
          }
        ], 'entityMap': {}
      },
      'strategyDescendantText': {
        'blocks': [
          {
            'key': '9algj',
            'text': 'In less than 2 minutes, find the right strategy for your needs.',
            'type': 'BODY2',
            'depth': 0,
            'inlineStyleRanges': [],
            'entityRanges': [],
            'data': {}
          }
        ], 'entityMap': {}
      },
      'mapDescendantText': {
        'blocks': [
          {
            'key': '3dvc',
            'text': 'Tap a map pin to view agent details or zoom the map out if no agents show up in your immediate area. We may also have additional agents available that are not shown on the map so please call us at 1-800-294-9940 and we can get you in contact with an agent near you.',
            'type': 'CAPTION',
            'depth': 0,
            'inlineStyleRanges': [],
            'entityRanges': [],
            'data': {}
          }
        ], 'entityMap': {}
      },
      'mapTitle': {
        'blocks': [
          {
            'key': '81m1v',
            'text': 'Licensed Agents Map',
            'type': 'H2',
            'depth': 0,
            'inlineStyleRanges': [],
            'entityRanges': [],
            'data': {}
          }
        ], 'entityMap': {}
      },

      'bgImage': 'img-hero-agent-lookup.jpg',
      'carouselId': 3
    },
    data: {
      'subTitle': {
        'blocks': [
          {
            'key': 'fraau',
            'text': subTitle,
            'type': 'SUBTITLE1',
            'depth': 0,
            'inlineStyleRanges': [],
            'entityRanges': [],
            'data': {}
          }
        ], 'entityMap': {}
      },
      'registerTitle': {
        'blocks': [
          {
            'key': 'fraau',
            'text': 'Need to register?',
            'type': 'H4',
            'depth': 0,
            'inlineStyleRanges': [],
            'entityRanges': [],
            'data': {}
          }
        ], 'entityMap': {}
      },
      'registerText': {
        'blocks': [
          {
            'key': 'fraau',
            'text': 'Become an approved agent to access resources.',
            'type': 'BODY2',
            'depth': 0,
            'inlineStyleRanges': [],
            'entityRanges': [],
            'data': {}
          }
        ], 'entityMap': {}
      },
      'preferredTitle': {
        'blocks': [
          {
            'key': 'fraau',
            'text': 'Are you an NIW Preferred Agent?',
            'type': 'H4',
            'depth': 0,
            'inlineStyleRanges': [],
            'entityRanges': [],
            'data': {}
          }
        ], 'entityMap': {}
      },
      'preferredText': {
        'blocks': [
          {
            'key': 'fraau',
            'text': 'Preferred agents have access to ilia, NIW\'s robust client management and enrollment portal for Kai-Zen',
            'type': 'BODY2',
            'depth': 0,
            'inlineStyleRanges': [],
            'entityRanges': [],
            'data': {}
          }
        ], 'entityMap': {}
      },
    },
    keyword: 'agent resources',
    description: 'Agent resources like marketing materials, training, sample illustrations, enrollment forms, and more. '
  };


  return (
    <AppContext.Provider value={props.page}>
      <Layout
        title={props.title}
        description={props.data.subTitle}
        keyword={props.keyword}
        pageDescription={props.description}
      >
        <RegisterConfirmation title={props.page.title} {...props.data} />
      </Layout>
    </AppContext.Provider>
  );
}

const RegisterConfirmation = ({title, subTitle}: any) => {
  return (
    <>
      <Banner title={title} subTitle={subTitle}/>
      <div className="sectionPD">
        <Container maxWidth="lg">
          <Grid container spacing={2} justifyContent="space-between">
            <Grid item xs={12} md={6}>
              <Typography color="primary" component="strong" className="f28 mb20 floatLeft w100">
                Thank You
              </Typography>
              <Typography className="mb20">
                Once your application has been reviewed you will receive a confirmation
                email and will be able to log in with your email and the password you created
                during registration. This can take up to two business days so please be patient.
                <br/><br/><strong>Once approved, you will be required to review and sign the NIW Simplicity Selling Agreement when you
                first log in.</strong><br/><br/>
                For questions please email <a href="mailto:niw.selling@simplicitygroup.com">niw.selling@simplicitygroup.com</a>
              </Typography>
              <Link href="/agent-resources">
                <Button
                  size="medium" type="submit" variant="contained" color="primary"
                >
                  Back to login
                </Button>
              </Link>
            </Grid>
          </Grid>
        </Container>
      </div>
    </>
  )
}

export default RegisterAgentConfirmation;
